import {useMutation, useQuery} from "react-query";
import axios from "axios";
import {getAuthConfig} from "../utils";
const auth = getAuthConfig()

export function GetSessions({updated, id, limit = 50, survey, contact} = {}) {
    const params = new URLSearchParams()
    if (updated) params.append("updated", updated)
    if (id) params.append("id", id)
    if (limit) params.append("limit", limit)
    if (survey) params.append("survey", survey)
    if (contact) params.append("contact", contact)
    const queryString = params.toString()
    const url = `/api/v2/session.php/${queryString ? "?" + queryString : ""}`

    return useQuery(["sessions", {updated, id, limit, survey, contact}], async () => {
        const {data} = await axios.get(url, auth)
        return data
    }, {
        enabled: false,
    })
}

export function useGetSessions() {
    return useMutation("fetchSessions", async ({updated, id, limit = 50, survey, contact} = {}) => {
        const params = new URLSearchParams()
        if (updated) params.append("updated", updated)
        if (id) params.append("id", id)
        if (limit) params.append("limit", limit.toString())
        if (survey) params.append("survey", survey)
        if (contact) params.append("contact", contact)
        const queryString = params.toString()
        const url = `/api/v2/session.php/${queryString ? "?" + queryString : ""}`
        const {data} = await axios.get(url, auth)
        return data
    })
}

export function GetSessionById(sessionId) {
    return useQuery(["session", sessionId], async () => {
        const {data} = await axios.get(
            `/api/v2/session.php/${sessionId}`,
            auth
        )
        return data
    }, {
        enabled: !!sessionId,
    })
}

export function useTriggerLLMAnalysis() {
    return useMutation("triggerLLMAnalysis", async ({session, survey, force, analysisaiagent} = {}) => {
        const params = new URLSearchParams()
        if (session) params.append("session", session)
        if (survey) params.append("survey", survey)
        if (force) params.append("force", "true")
        if (analysisaiagent) params.append("analysisaiagent", analysisaiagent)
        const queryString = params.toString()
        const url = `/api/v2/session-llmanalysis.php${queryString ? "?" + queryString : ""}`
        const {data} = await axios.get(url, auth)
        return data
    })
}
